import { axiosGet } from './service';

export async function getMemberList() {
  return axiosGet('/Member/List');
}

export async function getMemberSearchList(model) {
    return axiosGet('/Member/SearchList', model);
}